


































import { Component, Vue } from "@/shared/vuepack";
import { useHsabExpenseFormStore } from "@/employee/store/hsabExpenseForm";
import {
  CombinedClaimReceiptStatus,
  HsabExpenseRelationshipResponse,
  HsabExpenseResponse,
  RelationshipType
} from "@/shared/types";
import _ from "lodash";
import moment from "moment";
import HsabExpenseReimbursementStatusPill from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseReimbursementStatusPill.vue";

@Component({
  components: {
    HsabExpenseReimbursementStatusPill
  }
})
export default class HsabExpenseCardRowRelationships extends Vue {
  hsabExpenseFormStore = useHsabExpenseFormStore();
  combinedClaimReceiptStatus = CombinedClaimReceiptStatus;

  get expense (): HsabExpenseResponse {
    return this.hsabExpenseFormStore.expense;
  }

  get relationships (): Record<string, HsabExpenseRelationshipResponse[]> {
    if (!this.expense) {
      return {};
    }
    return _.groupBy(this.expense.relationships, r => r.relationshipType);
  }

  getDisplayForRelationshipTypeString (t: string): string {
    switch (t) {
      case RelationshipType.Unknown:
      case RelationshipType.ClonedDueToWexRequirements:
        return "";
      case RelationshipType.ClonedFromRecurringTemplate:
        return "Submitted Expenses";
      default:
        return "";
    }
  }

  isRelationshipsObjectEmpty () {
    return _.isEmpty(this.relationships);
  }

  getDateDisplay (str) {
    return moment(str).format("MMM Do, YYYY");
  }

  onRelatedExpenseClicked (expense: HsabExpenseResponse) {
    this.hsabExpenseFormStore.loadExpenseForViewOrEdit(expense.hsabExpenseId);
  }
}
